import { render, staticRenderFns } from "./AddPublicationTooltip.vue?vue&type=template&id=0876c4a6&scoped=true"
import script from "./AddPublicationTooltip.vue?vue&type=script&lang=js"
export * from "./AddPublicationTooltip.vue?vue&type=script&lang=js"
import style0 from "./AddPublicationTooltip.vue?vue&type=style&index=0&id=0876c4a6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0876c4a6",
  null
  
)

export default component.exports